// 活动通用 buff：列表 GET + 使用 POST
import request from '@/core/request'
import type { ResponseData } from '@/service/type'

export type UiBuffCardItem = {
  buff_id: number
  buff_ratio: number | string
  buff_duration: number
  buff_desc?: string
}

export async function getBuffCards(activity_code: string): Promise<ResponseData<{ buff_cards: UiBuffCardItem[] }>> {
  return (await request.get('/api/activities/general/buff_cards', {
    activity_code,
  })) as ResponseData<{ buff_cards: UiBuffCardItem[] }>
}

export type PostUseBuffCardParams = {
  buff_id: number
  activity_code: string
}

export async function postUseBuffCard(params: PostUseBuffCardParams): Promise<ResponseData<{}>> {
  return await request.post('/api/activities/general/buff_card/use', params)
}

/** 供 useQuery / invalidateQueries 与组件内一致 */
export const GENERAL_BUFF_CARDS_QUERY_KEY = 'generalBuffCards' as const
